import React, { Component, Fragment } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { getText } from '../helpers';

class Feedback extends Component {
  constructor(props){
    super(props);
    this.state = {
      shown: false,
      email: {
        recipients: ['lance.keys@angloamerican.com', 'marcos.peres@angloamerican.com'],
        subject: 'Anglo InterWRACtive Feedback',
        body: ''
      }

    }
  }

  toggleModal = (evt) => {
    this.setState({
      shown: !this.state.shown
    })
  }

  render() {
    const { subject, recipients } = this.state.email;
    var trigger = <div className="send-feedback" onClick={this.toggleModal}><i className="mail icon"></i><div>{getText('Send Feedback')}</div></div>

    return (
      <Modal trigger={trigger} size="tiny" open={this.state.shown} onClose={this.toggleModal}>
        <Modal.Header>{getText('Send your feedback')}</Modal.Header>
        <Modal.Content>
          <div>
            <span>{getText('Please send your feedback to')} </span>
            <span>
              {
                recipients.map((email, index)=>{
                  return (
                    <Fragment>
                      <a href={`mailto:${email}?subject=${subject}`}><u><b>{email}</b></u></a>
                      { index < recipients.length - 1 && <span> or </span> }
                      { index === recipients.length - 1 && <span>.</span> }
                    </Fragment>
                  )
                })
              }
            </span>
            <br/>
            <span>{getText('Make the subject as')} '<strong>{subject}</strong>'.</span>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color='teal' fluid size='medium' loading={false} onClick={this.toggleModal} className="send-feedback-btn">{getText('Close')}</Button>
        </Modal.Actions>
        <i className="delete icon" onClick={this.toggleModal}></i>
      </Modal>
    )
  }
}

export default Feedback



// WEBPACK FOOTER //
// ./src/components/feedback.js